module.exports = __webpack_public_path__ + "static/spacecomputer-0435e7fad303777031a4f48e9d15d22b.gif";